<template>
  <div class="vmv-container">
    <div class="vmv-header">
      <span class="back" @click="$router.push('/home')">&#8592;</span>
      <span class="title">车辆管理</span>
    </div>
    <div class="vmv-search">
      <div class="vmv-search-box">
        <span class="icon">🔍</span>
        <input type="text" class="vmv-search-input" v-model.trim="keyword" placeholder="搜索车牌号码">
        <button class="vmv-search-btn" @click="search">搜索</button>
      </div>
    </div>
    <div class="vmv-list" ref="plateListContainer" @scroll="handleScroll">
      <div class="vmv-plate-card" v-for="(p,i) in filtered" :key="p.num || i">
        <div class="vmv-plate-details">
          <div class="vmv-plate-header">
          <div class="vmv-plate-number">{{ p.num }}</div>
          </div>
          <div class="vmv-plate-info">有效期: {{ getValidityPeriod(p.num) }}</div>
        </div>
        <span class="vmv-right-actions">
          <button
            v-if="showManageActions"
            class="vmv-edit-btn"
            @click="openEdit(p)"
          >
            编辑
          </button>
          <button
            v-if="showManageActions"
            class="vmv-delete-btn"
            @click="openConfirm(p)"
          >
            删除
          </button>
          <span class="vmv-arrow">&#8250;</span>
        </span>
      </div>
      <!-- 加载更多提示 -->
      <div v-if="plateListLoading" class="load-more-loading">加载中...</div>
      <div v-if="!plateListLoading && hasMorePlateList && list.length > 0" class="load-more-hint">继续滚动加载更多</div>
      <div v-if="!plateListLoading && !hasMorePlateList && list.length > 0" class="load-more-hint">没有更多了</div>
    </div>
    <!-- 自定义确认弹窗 -->
    <div class="confirm-mask" v-if="confirmVisible">
      <div class="confirm-dialog">
        <div class="confirm-title">确认删除</div>
        <div class="confirm-content">是否确认从月卡订单中删除车牌 <b>{{ confirmItem && confirmItem.num }}</b> ？该操作不可撤销。</div>
        <div class="confirm-actions">
          <button class="btn cancel" @click="confirmVisible=false">取消</button>
          <button class="btn danger" :disabled="loading" @click="doDelete(confirmItem)">{{ loading ? '删除中...' : '确定' }}</button>
        </div>
      </div>
    </div>
    <div v-if="showManageActions" class="vmv-bottom-btns">
      <button @click="$router.push('/vehicle/add')" style="flex:1;background:linear-gradient(90deg,#4ca1ff,#70e1f5);color:#fff;font-size:16px;font-weight:500;border:none;border-radius:12px;padding:8px 0;margin-right:12px;">+ 添加车牌</button>
      <button @click="openClearAll" style="flex:1;background:#f7f8fa;color:#3572e6;font-size:16px;font-weight:500;border:none;border-radius:12px;padding:8px 0;">一键清空</button>
    </div>

    <!-- 一键清空确认弹窗 -->
    <div class="confirm-mask" v-if="clearAllVisible">
      <div class="confirm-dialog">
        <div class="confirm-title">一键清空</div>
        <div class="confirm-content">将从月卡订单中删除当前列表中<b>{{ list.length }}</b> 个车牌号。该操作不可撤销，是否继续？</div>
        <div class="confirm-actions">
          <button class="btn cancel" @click="clearAllVisible=false">取消</button>
          <button class="btn danger" :disabled="loading" @click="doClearAll()">{{ loading ? '清空中...' : '确定' }}</button>
        </div>
      </div>
    </div>

    <!-- 编辑车牌号弹窗 -->
    <div class="confirm-mask" v-if="editVisible">
      <div class="confirm-dialog edit-dialog">
        <div class="confirm-title">编辑车牌号</div>
        <div class="confirm-content">
          <div class="edit-form">
            <div class="edit-label">当前车牌号：</div>
            <div class="edit-current-plate">{{ editItem && editItem.num }}</div>
            <div class="edit-label">新车牌号：</div>
            <div 
              class="edit-input-plate" 
              @click="showKeyboard"
            >
              <span v-if="newPlateNumber" class="plate-display">{{ newPlateNumber }}</span>
              <span v-else class="plate-placeholder">点击输入新车牌号</span>
            </div>
          </div>
        </div>
        <div class="confirm-actions">
          <button class="btn cancel" @click="closeEdit">取消</button>
          <button class="btn primary" :disabled="loading || !newPlateNumber" @click="doUpdatePlate">{{ loading ? '更新中...' : '确定' }}</button>
        </div>
      </div>
    </div>
    
    <!-- 车牌号键盘 -->
    <PlateKeyboard
      :visible="keyboardVisible"
      :value="newPlateNumber"
      :maxLength="8"
      @input="handlePlateInput"
      @close="handleKeyboardClose"
    />
    
    <BottomNav />
  </div>
</template>

<script>
import BottomNav from '@/components/BottomNav.vue'
import PlateKeyboard from '@/components/PlateKeyboard.vue'
import { addBusinessOperationRecord } from '@/api/business-operation-record'
export default {
  name: 'VehiclePage',
  components: { BottomNav, PlateKeyboard },
  data () {
    return {
      keyword: '',
      list: [
      ],
      total: null,
      loading: false,
      confirmVisible: false,
      confirmItem: null,
      clearAllVisible: false,
      showManageActions: true, // 显示管理操作按钮（编辑、删除）
      plateToOrderMap: {}, // 车牌号到月卡订单的映射
      editVisible: false, // 编辑弹窗显示状态
      editItem: null, // 当前编辑的车辆项
      newPlateNumber: '', // 新车牌号
      keyboardVisible: false, // 车牌号键盘显示状态
      currentBusinessId: null, // 当前商户ID
      currentProductId: null, // 当前商家月卡套餐ID（可选，用于筛选）
      plateListPage: 1, // 车牌号列表当前页码
      plateListPageSize: 10, // 车牌号列表每页大小（订单的每页大小）
      plateListTotal: 0, // 订单总数
      loadedOrderCount: 0, // 已加载的订单数量
      plateListLoading: false, // 车牌号列表是否正在加载
      hasMorePlateList: false, // 是否还有更多订单
      allPlateNumbersSet: null // 所有已加载订单中的车牌号集合（用于去重）
    }
  },
  computed: {
    filtered () {
      if (!this.keyword) return this.list
      return this.list.filter(i => i.num.includes(this.keyword))
    }
  },
  watch: {
    // 监听搜索关键词变化，搜索后检查是否需要加载更多
    keyword () {
      this.$nextTick(() => {
        this.checkAndLoadMoreIfNeeded()
      })
    },
    // 监听列表变化，检查是否需要加载更多
    list () {
      this.$nextTick(() => {
        this.checkAndLoadMoreIfNeeded()
      })
    }
  },
  async mounted () {
    // 获取商户ID
    await this.fetchBusinessId()
    // 加载第一页车牌号列表
    if (this.currentBusinessId) {
      await this.fetchPlateList(this.currentBusinessId, null, 1, false)
    }
  },
  methods: {
    // 格式化时间，加上8小时（UTC+8时区）
    formatTime (v) {
      if (!v) return ''
      try {
        const d = new Date(v)
        if (isNaN(d.getTime())) {
          return String(v).slice(0, 16).replace('T', ' ')
        }
        // 加上8小时（8 * 60 * 60 * 1000 毫秒）
        const dPlus8 = new Date(d.getTime() + 8 * 60 * 60 * 1000)
        return dPlus8.toISOString().slice(0, 16).replace('T', ' ')
      } catch (e) {
        return String(v).slice(0, 16).replace('T', ' ')
      }
    },
    search () { return undefined },
    // 检查列表内容是否不足，如果不足则加载下一页
    async checkAndLoadMoreIfNeeded () {
      // 如果没有关键词（未搜索），不自动加载
      if (!this.keyword || !this.keyword.trim()) {
        return
      }
      
      // 如果正在加载或没有更多数据，不自动加载
      if (this.plateListLoading || !this.hasMorePlateList) {
        return
      }
      
      // 等待DOM更新完成
      await this.$nextTick()
      
      // 获取列表容器
      const container = this.$refs.plateListContainer
      if (!container) {
        return
      }
      
      // 计算容器高度和内容高度
      const containerHeight = container.clientHeight || 0
      const scrollHeight = container.scrollHeight || 0
      
      // 如果内容高度小于等于容器高度（说明内容不足，不需要滚动就能看到全部），则加载下一页
      // 添加一个小缓冲区（10px），避免因为计算误差导致的无限加载
      if (scrollHeight <= containerHeight + 10 && this.hasMorePlateList && !this.plateListLoading) {
        console.log('[Vehicle] 搜索结果内容不足，自动加载下一页:', {
          containerHeight,
          scrollHeight,
          currentPage: this.plateListPage,
          hasMore: this.hasMorePlateList,
          filteredCount: this.filtered.length
        })
        
        const nextPage = this.plateListPage + 1
        await this.fetchPlateList(this.currentBusinessId, this.currentProductId, nextPage, true)
        
        // 加载完成后，fetchPlateList 内部会再次调用 checkAndLoadMoreIfNeeded
        // 这样形成循环检查，直到内容足够或没有更多数据
      }
    },
    // 获取商户ID
    async fetchBusinessId () {
      try {
        // 获取用户ID
        let userId = localStorage.getItem('userId')
        if (!userId) {
          const token = localStorage.getItem('token')
          if (token) {
            try {
              const parts = token.split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                userId = payload.userId || payload.uid || payload.sub || null
              }
            } catch (e) { /* ignore */ }
          }
        }
        if (!userId) {
          console.warn('[Vehicle] 未能获取用户ID，无法查询商户列表')
          return
        }
        
        // 查询商户列表
        const req = (await import('@/utils/request')).default
        const merchantRes = await req({
          url: '/market/business/list',
          method: 'post',
          data: { administor: userId },
          timeout: 30000
        })
        const merchantList = merchantRes?.data || []
        if (merchantList.length > 0) {
          this.currentBusinessId = merchantList[0].businessId
          console.log('[Vehicle] 获取到商户ID:', this.currentBusinessId)
        } else {
          console.warn('[Vehicle] 未找到商户信息')
        }
      } catch (e) {
        console.error('[Vehicle] 获取商户ID失败:', e)
      }
    },
    // 处理滚动事件，实现滚动到底部自动加载
    handleScroll (event) {
      const container = event.target || event.currentTarget
      if (!container) return
      
      // 计算是否滚动到底部（距离底部100px内）
      const scrollTop = container.scrollTop || 0
      const scrollHeight = container.scrollHeight || 0
      const clientHeight = container.clientHeight || 0
      const scrollBottom = scrollHeight - scrollTop - clientHeight
      
      console.log('[Vehicle] 滚动事件:', {
        scrollTop,
        scrollHeight,
        clientHeight,
        scrollBottom,
        hasMore: this.hasMorePlateList,
        loading: this.plateListLoading
      })
      
      if (scrollBottom < 100 && this.hasMorePlateList && !this.plateListLoading) {
        // 加载下一页
        const nextPage = this.plateListPage + 1
        console.log('[Vehicle] 触发加载下一页:', nextPage)
        this.fetchPlateList(this.currentBusinessId, this.currentProductId, nextPage, true)
      }
    },
    // 获取车牌号列表（分页，滚动到底部时加载下一页）
    async fetchPlateList (businessId, productId = null, page = 1, append = false) {
      if (!businessId) {
        console.warn('[Vehicle] 商户ID为空，无法查询车牌号列表')
        return
      }
      
      // 如果正在加载，不重复请求
      if (this.plateListLoading) {
        return
      }
      
      this.plateListLoading = true
      
      console.log('[Vehicle] 开始查询车牌号列表:', { businessId, productId, page, append })
      
      try {
        const req = (await import('@/utils/request')).default
        const base = process.env.NODE_ENV === 'development' ? 'http://localhost:8100' : ''
        
        const resp = await req({
          url: `${base}/market/business/card/order/search/plate-numbers`,
          method: 'get',
          params: {
            businessId: businessId,
            productId: productId || undefined,
            page: page,
            size: this.plateListPageSize
          },
          timeout: 30000
        })
        
        // 解析响应数据
        let responseData = resp?.data || {}
        if (responseData.data) {
          responseData = responseData.data
        }
        
        // 提取订单列表和车牌号列表
        const orders = Array.isArray(responseData.orders) ? responseData.orders : []
        const plateNumbers = Array.isArray(responseData.plateNumbers) ? responseData.plateNumbers : []
        const orderTotal = responseData.total || 0 // 订单总数
        
        console.log('[Vehicle] 查询到车牌号列表:', {
          page,
          orderCount: orders.length,
          plateCount: plateNumbers.length,
          orderTotal,
          loadedOrderCount: this.loadedOrderCount
        })
        
        // 初始化或更新车牌号集合（用于去重）
        if (!append) {
          // 重置模式：重新建立映射关系和车牌号集合
          this.plateToOrderMap = {}
          this.allPlateNumbersSet = new Set()
          this.loadedOrderCount = 0
        }
        
        // 累加当前页的车牌号到集合中（去重）
        plateNumbers.forEach(plate => {
          const normalized = String(plate).trim().toUpperCase()
          if (normalized.length > 0) {
            this.allPlateNumbersSet.add(normalized)
          }
        })
        
        // 建立车牌号到订单的映射关系（用于编辑、删除等功能）
        orders.forEach(order => {
          const orderId = order?.orderId || order?.id || order?.order_id
          if (!orderId) return
          
          const plates = order?.plateNumbers || 
                         order?.plateNumberList || 
                         order?.plateList || 
                         order?.plates || []
          
          if (Array.isArray(plates)) {
            plates.forEach(plate => {
              if (!plate) return
              const normalized = String(plate).trim().toUpperCase()
              if (normalized.length === 0) return
              
              // 建立映射关系
              if (!this.plateToOrderMap[normalized]) {
                this.plateToOrderMap[normalized] = []
              }
              // 避免重复添加同一个订单
              const existing = this.plateToOrderMap[normalized].find(o => {
                const oid = o?.orderId || o?.id || o?.order_id
                return oid === orderId
              })
              if (!existing) {
                this.plateToOrderMap[normalized].push(order)
              }
            })
          }
        })
        
        // 更新已加载的订单数量
        this.loadedOrderCount += orders.length
        
        // 更新订单总数（首次加载时）
        if (this.plateListTotal === 0 && orderTotal > 0) {
          this.plateListTotal = orderTotal
        }
        
        // 更新分页信息
        this.plateListPage = page
        
        // 判断是否还有更多订单
        // 如果已加载的订单数量 < 订单总数，说明还有更多订单
        const hasMoreOrders = this.loadedOrderCount < this.plateListTotal
        
        // 将所有去重后的车牌号转换为列表格式
        const allPlateList = Array.from(this.allPlateNumbersSet).map(plate => ({
          id: null,
          num: plate,
          time: ''
        }))
        
        // 更新显示列表（使用所有已加载订单中的车牌号，去重后）
        this.list = allPlateList
        
        // 更新是否还有更多数据的标志（基于订单数量判断）
        this.hasMorePlateList = hasMoreOrders
        
        console.log('[Vehicle] 车牌号列表加载完成:', {
          page,
          loadedOrderCount: this.loadedOrderCount,
          orderTotal: this.plateListTotal,
          uniquePlateCount: this.allPlateNumbersSet.size,
          currentListLength: this.list.length,
          hasMoreOrders
        })
        
        // 加载完成后，如果是在搜索状态下且内容不足，检查是否需要自动加载更多
        if (this.keyword && this.keyword.trim()) {
          this.$nextTick(() => {
            this.checkAndLoadMoreIfNeeded()
          })
        }
      } catch (e) {
        console.error('[Vehicle] 查询车牌号列表失败:', e)
        if (!append) {
          this.list = []
          this.allPlateNumbersSet = null
          this.loadedOrderCount = 0
        }
      } finally {
        this.plateListLoading = false
      }
    },
    // 根据车牌号获取对应的月卡订单
    getOrdersByPlate (plateNumber) {
      if (!plateNumber || !this.plateToOrderMap) return []
      const normalized = String(plateNumber).trim().toUpperCase()
      return this.plateToOrderMap[normalized] || []
    },
    // 获取商户ID（从订单中获取，或从 businessContext 中获取）
    getBusinessIdFromOrder (order) {
      if (!order) return null
      // 尝试多种可能的字段名
      let businessId = order.businessId || order.business_id || null
      
      // 如果订单中没有 businessId，尝试从 businessContext 中获取
      if (!businessId) {
        try {
          const raw = sessionStorage.getItem('in_park_plates_payload')
          if (raw) {
            const payload = JSON.parse(raw)
            const businessContext = payload?.businessContext
            if (businessContext) {
              businessId = businessContext.businessId || businessContext.business_id || null
            }
          }
        } catch (e) {
          console.warn('[Vehicle] 从 businessContext 获取 businessId 失败:', e)
        }
      }
      
      return businessId
    },
    // 获取操作人ID（参考 Recharge.vue 和 Profile.vue 的实现）
    getOperatorId () {
      // 优先从 store.state.user.id 获取（与 Recharge.vue 保持一致）
      const fromStore = this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.id
      if (fromStore) {
        console.log('[Vehicle] 从 store.state.user.id 获取操作人ID:', fromStore)
        return fromStore
      }
      
      // 其次从 store.getters.userInfo 获取
      if (this.$store && this.$store.getters) {
        const userInfo = this.$store.getters.userInfo
        if (userInfo) {
          const uid = userInfo.userId || userInfo.id
          if (uid) {
            console.log('[Vehicle] 从 store.getters.userInfo 获取操作人ID:', uid)
            return uid
          }
        }
        // 如果 userInfo 中没有，尝试从 getters 直接获取
        const userId = this.$store.getters.userId || this.$store.getters.user_id
        if (userId) {
          console.log('[Vehicle] 从 store.getters.userId 获取操作人ID:', userId)
          return userId
        }
      }
      
      // 再次从 localStorage 获取
      const localStorageUserId = localStorage.getItem('userId')
      if (localStorageUserId) {
        console.log('[Vehicle] 从 localStorage 获取操作人ID:', localStorageUserId)
        return localStorageUserId
      }
      
      // 最后从 token 解析
      try {
        const token = localStorage.getItem('token') || ''
        const parts = (token || '').split('.')
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]))
          // 尝试多种可能的字段名
          const cand = payload.userId || payload.uid || payload.sub || payload.user_id || payload.id || null
          if (cand) {
            console.log('[Vehicle] 从 token 解析获取操作人ID:', cand)
            return cand
          }
        }
      } catch (e) {
        console.warn('[Vehicle] 从 token 解析 operatorId 失败:', e)
      }
      
      console.warn('[Vehicle] 无法获取操作人ID，所有方式都尝试过了')
      return null
    },
    // 获取操作人名称（用于月卡操作记录：CardOrderService.update 读取 operatorName）
    getOperatorName () {
      // 1) 优先从 store 获取
      try {
        const fromState =
          this.$store &&
          this.$store.state &&
          this.$store.state.user &&
          (this.$store.state.user.name || (this.$store.state.user.info && (this.$store.state.user.info.realName || this.$store.state.user.info.username || this.$store.state.user.info.name)))
        if (fromState) return String(fromState)

        const userInfo = this.$store && this.$store.getters && this.$store.getters.userInfo
        if (userInfo) {
          const n = userInfo.realName || userInfo.username || userInfo.userName || userInfo.name || ''
          if (n) return String(n)
        }
      } catch (e) { /* ignore */ }

      // 2) 再从 token 解析
      try {
        const token = localStorage.getItem('token') || ''
        const parts = (token || '').split('.')
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]))
          const n = payload.realName || payload.username || payload.userName || payload.name || ''
          if (n) return String(n)
        }
      } catch (e) { /* ignore */ }

      return ''
    },
    // 添加操作记录
    async addOperationRecord (orderId, businessId, operationContent) {
      try {
        const operatorId = this.getOperatorId()
        console.log('[Vehicle] 准备添加操作记录:', { orderId, businessId, operatorId, operationContent })
        
        if (!operatorId) {
          console.warn('[Vehicle] 无法获取操作人ID，跳过操作记录')
          return
        }
        if (!businessId) {
          console.warn('[Vehicle] 商户ID为空，跳过操作记录')
          return
        }
        if (!orderId) {
          console.warn('[Vehicle] 订单ID为空，跳过操作记录')
          return
        }
        
        const result = await addBusinessOperationRecord({
          orderId: orderId,
          businessId: businessId,
          operatorId: operatorId,
          operationContent: operationContent
        })
        console.log('[Vehicle] 操作记录添加成功', { orderId, businessId, operationContent, result })
      } catch (e) {
        // 操作记录添加失败不影响主流程，只记录日志
        console.error('[Vehicle] 添加操作记录失败:', e, { orderId, businessId, operationContent })
      }
    },
    // 格式化日期显示
    formatDate (v) {
      if (!v) return ''
      try {
        const d = new Date(v)
        if (!isNaN(d.getTime())) {
          return `${d.getFullYear()}年${('0'+(d.getMonth()+1)).slice(-2)}月${('0'+d.getDate()).slice(-2)}日`
        }
        return String(v).slice(0, 10)
      } catch (e) { 
        return String(v).slice(0, 10) 
      }
    },
    // 获取车牌号对应的有效期
    getValidityPeriod (plateNumber) {
      if (!plateNumber) return '-'
      const orders = this.getOrdersByPlate(plateNumber)
      if (!Array.isArray(orders) || orders.length === 0) return '-'
      
      // 取第一个订单的有效期（通常一个车牌号对应一个订单，如果有多个则取第一个）
      const order = orders[0]
      const startTime = order?.cardValidStartTime || order?.card_valid_start_time
      const endTime = order?.cardValidEndTime || order?.card_valid_end_time
      
      if (!startTime && !endTime) return '-'
      
      const startStr = this.formatDate(startTime)
      const endStr = this.formatDate(endTime)
      
      if (startStr && endStr) {
        return `${startStr}至${endStr}`
      } else if (endStr) {
        return `至${endStr}`
      } else if (startStr) {
        return `自${startStr}`
      }
      
      return '-'
    },
    openConfirm (item) {
      // 接收的是 filtered 数组中的项，不是索引
      if (!item) return
      this.confirmItem = item
      this.confirmVisible = true
    },
    async doDelete (item) {
      // 接收的是 filtered 数组中的项，不是索引
      if (!item) return
      this.confirmVisible = false
      
      const plate = item.num
      if (!plate) {
        alert('车牌号为空，无法删除')
        return
      }
      
      try {
        this.loading = true
        const req = (await import('@/utils/request')).default

        // 1) 获取该车牌号对应的月卡订单
        const orders = this.getOrdersByPlate(plate)
        console.log('[vehicle] 删除操作：', { 
          plate, 
          ordersCount: orders?.length || 0,
          plateToOrderMapKeys: Object.keys(this.plateToOrderMap)
        })
        
        if (!Array.isArray(orders) || orders.length === 0) {
          alert('未找到该车牌号对应的月卡订单，无法删除')
          return
        }
        
        // 2) 从每个订单中删除该车牌号
        const updateUrl = '/market/card/order/update'
        const normalizedPlate = String(plate).trim().toUpperCase()
        
        let successCount = 0
        let failCount = 0
        const updatedOrders = [] // 用于收集更新后的订单数据
        
        for (const order of orders) {
          try {
            const orderId = order?.orderId || order?.id || order?.order_id
            if (!orderId) {
              console.warn('[vehicle] 订单ID为空，跳过删除', order)
              failCount++
              continue
            }
            
            // 关键修复：在删除前先获取订单的最新数据，避免使用缓存中的旧数据
            let latestOrder = await this.fetchLatestOrderData(orderId)
            if (!latestOrder) {
              // 如果获取最新数据失败，使用缓存数据（向后兼容）
              console.warn('[vehicle] 无法获取订单最新数据，使用缓存数据', { orderId })
              latestOrder = order
            }
            
            // 使用最新订单数据获取车牌号列表
            const currentPlates = latestOrder?.plateNumbers || latestOrder?.plateNumberList || latestOrder?.plateList || latestOrder?.plates || []
            const plateArray = Array.isArray(currentPlates) ? [...currentPlates] : (currentPlates ? [currentPlates] : [])
            
            console.log('[vehicle] 删除前订单车牌号列表:', { 
              orderId, 
              plateArray, 
              normalizedPlate,
              hasLatestData: !!latestOrder && latestOrder !== order
            })
            
            // 检查订单中是否包含要删除的车牌号
            const hasPlate = plateArray.some(p => {
              const normalized = String(p).trim().toUpperCase()
              return normalized === normalizedPlate
            })
            
            // 如果订单中不包含该车牌号，跳过（可能已经被其他操作删除）
            if (!hasPlate) {
              console.log('[vehicle] 订单中不包含该车牌号，跳过删除', { orderId, plate, plateArray })
              successCount++ // 认为成功（目标已达成）
              continue
            }
            
            // 获取车牌颜色数组（使用最新订单数据）
            const currentColors = latestOrder?.plateColors || latestOrder?.plate_colors || []
            const colorArray = Array.isArray(currentColors) ? [...currentColors] : []
            
            // 同步构建新的车牌号数组和颜色数组，确保一一对应
            // 重要：只删除当前显示的车牌号（编辑后的），不要删除其他车牌号，同时过滤掉空字符串
            const newPlateArray = []
            const newColorArray = []
            
            plateArray.forEach((p, idx) => {
              const normalized = String(p).trim().toUpperCase()
              // 只保留非空且不是要删除的车牌号
              if (normalized.length > 0 && normalized !== normalizedPlate) {
                newPlateArray.push(normalized)
                // 同步保留对应的颜色，如果颜色数组长度不足则使用默认值
                if (idx < colorArray.length) {
                  newColorArray.push(colorArray[idx])
                } else {
                  // 如果颜色数组长度不足，根据车牌号自动识别颜色
                  newColorArray.push(this.identifyPlateColor(normalized))
                }
              }
            })
            
            console.log('[vehicle] 删除后订单车牌号列表:', { orderId, newPlateArray })
            
            // 如果颜色数组长度不匹配，使用默认值补齐（理论上不应该发生，但作为保险）
            while (newColorArray.length < newPlateArray.length) {
              const plateIndex = newColorArray.length
              if (plateIndex < newPlateArray.length) {
                newColorArray.push(this.identifyPlateColor(newPlateArray[plateIndex]))
              } else {
                newColorArray.push('BLUE_WHITE_COLOR')
              }
            }
            
            // 构建更新请求（确保必填字段存在，使用最新订单数据）
            const updatePayload = {
              orderId: orderId,
              plateNumbers: newPlateArray,
              plateColors: newColorArray.length > 0 ? newColorArray : undefined,
              // 保持其他字段不变（使用最新订单数据）
              productId: latestOrder?.productId || latestOrder?.product_id || order?.productId || order?.product_id,
              status: latestOrder?.status || order?.status,
              cardValidStartTime: latestOrder?.cardValidStartTime || latestOrder?.card_valid_start_time || order?.cardValidStartTime || order?.card_valid_start_time,
              cardValidEndTime: latestOrder?.cardValidEndTime || latestOrder?.card_valid_end_time || order?.cardValidEndTime || order?.card_valid_end_time,
              // totalAmount 是必填字段
              totalAmount: latestOrder?.totalAmount || latestOrder?.total_amount || order?.totalAmount || order?.total_amount || 0,
              paidAmount: latestOrder?.paidAmount || latestOrder?.paid_amount || order?.paidAmount || order?.paid_amount || 0,
              actualAmount: latestOrder?.actualAmount || latestOrder?.actual_amount || order?.actualAmount || order?.actual_amount || 0,
              // 添加操作人ID和操作描述
              operatorId: this.getOperatorId(),
              operatorName: this.getOperatorName(),
              operationDesc: `删除车牌${normalizedPlate}`
            }
            
            // 验证必填字段
            if (!updatePayload.totalAmount && updatePayload.totalAmount !== 0) {
              console.error('[vehicle] 订单缺少必填字段 totalAmount', { orderId, latestOrder, order })
              failCount++
              continue
            }
            
            console.log('[vehicle] 发送删除请求', { orderId, updatePayload })
            await req({ url: updateUrl, method: 'post', data: updatePayload })
            successCount++
            console.log('[vehicle] 订单车牌号删除成功', { orderId, plate, newPlateArray })
            
            // 获取更新后的订单数据（用于更新 sessionStorage）
            const updatedOrder = await this.fetchLatestOrderData(orderId)
            if (updatedOrder) {
              updatedOrders.push(updatedOrder)
            } else {
              // 如果获取失败，使用更新后的数据构建订单对象
              updatedOrders.push({
                ...latestOrder,
                plateNumbers: newPlateArray,
                plateNumberList: newPlateArray,
                plateList: newPlateArray,
                plates: newPlateArray,
                plateColors: newColorArray,
                plate_colors: newColorArray
              })
            }
            
            // 添加操作记录
            const businessId = this.getBusinessIdFromOrder(latestOrder)
            if (businessId && orderId) {
              await this.addOperationRecord(
                orderId,
                businessId,
                `删除车牌号：${normalizedPlate}`
              )
            }
          } catch (e) {
            failCount++
            const errorMsg = e?.response?.data?.message || e?.message || String(e)
            const currentOrderId = order?.orderId || order?.id || order?.order_id || 'unknown'
            console.error('[vehicle] 删除订单车牌号失败', { 
              orderId: currentOrderId, 
              order, 
              error: e,
              errorMessage: errorMsg,
              response: e?.response?.data
            })
          }
        }
        
        if (successCount > 0) {
          // 从本地列表中移除该车辆（通过车牌号查找并删除，不使用索引）
          const normalizedPlate = String(plate).trim().toUpperCase()
          const foundIndex = this.list.findIndex(item => {
            const normalized = String(item.num || '').trim().toUpperCase()
            return normalized === normalizedPlate
          })
          
          if (foundIndex >= 0) {
            this.list.splice(foundIndex, 1)
            console.log('[vehicle] 从列表中移除车牌号:', { plate, index: foundIndex })
          } else {
            console.warn('[vehicle] 未在列表中找到要删除的车牌号:', plate)
          }
          
          // 更新映射关系（移除该车牌号的映射）
          if (this.plateToOrderMap[normalizedPlate]) {
            delete this.plateToOrderMap[normalizedPlate]
          }
          
          // 从车牌号集合中移除
          if (this.allPlateNumbersSet) {
            this.allPlateNumbersSet.delete(normalizedPlate)
          }
          
          // 更新 sessionStorage 中的订单数据，而不是清除整个缓存
          // 这样 VehicleAdd.vue 页面仍然可以访问到订单列表
          if (updatedOrders.length > 0) {
            this.updateSessionStorageOrders(updatedOrders)
          }
          
          // 删除成功后，重新加载列表（从第一页开始）
          this.plateListPage = 1
          this.list = []
          this.plateToOrderMap = {}
          this.loadedOrderCount = 0
          this.plateListTotal = 0
          this.allPlateNumbersSet = null
          await this.fetchPlateList(this.currentBusinessId, this.currentProductId, 1, false)
          
          // 清空搜索关键词
          this.keyword = ''
          
          alert(`删除成功！共从 ${successCount} 个订单中删除车牌号${failCount > 0 ? `，${failCount} 个订单删除失败` : ''}`)
        } else {
          const errorDetails = failCount > 0 ? `（共 ${failCount} 个订单）` : ''
          alert(`删除失败！所有订单删除都失败了${errorDetails}。请查看浏览器控制台了解详细错误信息。`)
        }
      } catch (e) {
        console.error('[vehicle] 删除车牌号失败', e)
        alert(e?.response?.data?.message || '删除失败，请稍后再试')
      } finally {
        this.loading = false
      }
    },
    // 兼容旧调用名
    async del (i) { return this.doDelete(i) },
    // 打开编辑弹窗
    openEdit (item) {
      // 接收的是 filtered 数组中的项，不是索引
      if (!item) return
      this.editItem = item
      this.newPlateNumber = item.num || ''
      this.editVisible = true
      this.keyboardVisible = false // 初始不显示键盘
    },
    // 显示车牌号键盘
    showKeyboard () {
      this.keyboardVisible = true
    },
    // 处理车牌号输入
    handlePlateInput (value) {
      this.newPlateNumber = value
    },
    // 关闭车牌号键盘
    handleKeyboardClose () {
      this.keyboardVisible = false
    },
    // 关闭编辑弹窗
    closeEdit () {
      this.editVisible = false
      this.keyboardVisible = false
      this.newPlateNumber = ''
      this.editItem = null
    },
    // 根据车牌号自动识别车牌颜色（参考商家月卡订单编辑页面逻辑）
    identifyPlateColor (plateNo) {
      if (!plateNo || plateNo.length < 6) {
        return 'UNKNOWN_COLOR'
      }

      const plate = String(plateNo).trim().toUpperCase()

      // 新能源车牌识别规则（8位）
      if (plate.length === 8) {
        // 8位车牌通常是新能源车牌
        if (plate.startsWith('京') || plate.startsWith('沪') || plate.startsWith('粤') ||
            plate.startsWith('浙') || plate.startsWith('苏') || plate.startsWith('鲁') ||
            plate.startsWith('川') || plate.startsWith('渝') || plate.startsWith('津') ||
            plate.startsWith('冀') || plate.startsWith('晋') || plate.startsWith('蒙') ||
            plate.startsWith('辽') || plate.startsWith('吉') || plate.startsWith('黑') ||
            plate.startsWith('皖') || plate.startsWith('闽') || plate.startsWith('赣') ||
            plate.startsWith('豫') || plate.startsWith('鄂') || plate.startsWith('湘') ||
            plate.startsWith('桂') || plate.startsWith('琼') || plate.startsWith('贵') ||
            plate.startsWith('云') || plate.startsWith('藏') || plate.startsWith('陕') ||
            plate.startsWith('甘') || plate.startsWith('青') || plate.startsWith('宁') ||
            plate.startsWith('新')) {
          return 'GREEN_BLACK_COLOR' // 绿底黑字
        }
      }

      // 普通车牌识别规则（7位）
      if (plate.length === 7) {
        // 7位车牌通常是普通车牌
        if (plate.startsWith('京') || plate.startsWith('沪') || plate.startsWith('粤') ||
            plate.startsWith('浙') || plate.startsWith('苏') || plate.startsWith('鲁') ||
            plate.startsWith('川') || plate.startsWith('渝') || plate.startsWith('津') ||
            plate.startsWith('冀') || plate.startsWith('晋') || plate.startsWith('蒙') ||
            plate.startsWith('辽') || plate.startsWith('吉') || plate.startsWith('黑') ||
            plate.startsWith('皖') || plate.startsWith('闽') || plate.startsWith('赣') ||
            plate.startsWith('豫') || plate.startsWith('鄂') || plate.startsWith('湘') ||
            plate.startsWith('桂') || plate.startsWith('琼') || plate.startsWith('贵') ||
            plate.startsWith('云') || plate.startsWith('藏') || plate.startsWith('陕') ||
            plate.startsWith('甘') || plate.startsWith('青') || plate.startsWith('宁') ||
            plate.startsWith('新')) {
          return 'BLUE_WHITE_COLOR' // 蓝底白字
        }
      }

      // 特殊车牌识别
      if (plate.startsWith('WJ') || plate.startsWith('军') || plate.startsWith('海') ||
          plate.startsWith('空') || plate.startsWith('北') || plate.startsWith('南') ||
          plate.startsWith('东') || plate.startsWith('西') || plate.startsWith('中')) {
        return 'WHITE_BLACK_COLOR' // 白底黑字
      }

      // 港澳车牌识别
      if (plate.startsWith('粤Z') || plate.includes('港') || plate.includes('澳')) {
        return 'BLACK_WHITE_COLOR' // 黑底白字
      }

      // 6位车牌识别（通常是新能源车牌）
      if (plate.length === 6) {
        if (plate.startsWith('粤Z') || plate.includes('港') || plate.includes('澳')) {
          return 'BLACK_WHITE_COLOR' // 黑底白字
        }
        return 'GREEN_WHITE_COLOR' // 绿底白字
      }

      // 默认返回蓝底白字（最常见的普通车牌）
      return 'BLUE_WHITE_COLOR'
    },
    // 更新车牌号
    async doUpdatePlate () {
      if (!this.newPlateNumber || !this.newPlateNumber.trim()) {
        alert('请输入新车牌号')
        return
      }
      const item = this.editItem
      if (!item) return
      
      const oldPlate = String(item.num).trim().toUpperCase()
      const newPlate = this.newPlateNumber.trim().toUpperCase()
      
      // 如果新车牌号与旧车牌号相同，不需要更新
      if (oldPlate === newPlate) {
        alert('新车牌号与当前车牌号相同，无需更新')
        this.closeEdit()
        return
      }
      
      try {
        this.loading = true
        
        // 1) 获取该车牌号对应的月卡订单
        const orders = this.getOrdersByPlate(oldPlate)
        if (!Array.isArray(orders) || orders.length === 0) {
          alert('未找到该车牌号对应的月卡订单，无法更新')
          return
        }
        
        // 2) 根据新车牌号自动识别车牌颜色
        const newPlateColor = this.identifyPlateColor(newPlate)
        
        // 3) 更新每个订单的车牌号
        const req = (await import('@/utils/request')).default
        const updateUrl = '/market/card/order/update'
        
        let successCount = 0
        let failCount = 0
        const updatedOrders = [] // 用于收集更新后的订单数据
        
        for (const order of orders) {
          try {
            const orderId = order?.orderId || order?.id || order?.order_id
            if (!orderId) {
              console.warn('[vehicle] 订单ID为空，跳过更新', order)
              failCount++
              continue
            }
            
            // 获取订单中的车牌号列表
            const currentPlates = order?.plateNumbers || order?.plateNumberList || order?.plateList || order?.plates || []
            const plateArray = Array.isArray(currentPlates) ? [...currentPlates] : [currentPlates]
            const currentColors = order?.plateColors || order?.plate_colors || []
            const colorArray = Array.isArray(currentColors) ? [...currentColors] : []
            
            // 找到所有旧车牌号在数组中的索引（可能有多个相同的旧车牌号）
            const oldPlateIndices = []
            plateArray.forEach((p, idx) => {
              const normalized = String(p).trim().toUpperCase()
              if (normalized === oldPlate) {
                oldPlateIndices.push(idx)
              }
            })
            
            // 如果订单中没有旧车牌号，跳过该订单（数据不一致）
            if (oldPlateIndices.length === 0) {
              console.warn('[vehicle] 订单中没有找到旧车牌号，跳过更新', { orderId, oldPlate, plateArray })
              failCount++
              continue
            }
            
            // 同步构建新的车牌号数组和颜色数组，确保一一对应
            // 步骤1：先删除所有旧车牌号及其对应的颜色，同时过滤掉空字符串
            const newPlateArray = []
            const newColorArray = []
            
            plateArray.forEach((p, idx) => {
              const normalized = String(p).trim().toUpperCase()
              // 只保留非空且不是旧车牌号的车牌号
              if (normalized.length > 0 && normalized !== oldPlate) {
                newPlateArray.push(normalized)
                // 同步保留对应的颜色，如果颜色数组长度不足则使用默认值
                if (idx < colorArray.length) {
                  newColorArray.push(colorArray[idx])
                } else {
                  // 如果颜色数组长度不足，根据车牌号自动识别颜色
                  newColorArray.push(this.identifyPlateColor(normalized))
                }
              }
            })
            
            // 步骤2：添加新车牌号及其自动识别的颜色
            newPlateArray.push(newPlate)
            newColorArray.push(newPlateColor)
            
            // 如果颜色数组长度不匹配，使用默认值补齐（理论上不应该发生，但作为保险）
            while (newColorArray.length < newPlateArray.length) {
              const plateIndex = newColorArray.length
              if (plateIndex < newPlateArray.length) {
                newColorArray.push(this.identifyPlateColor(newPlateArray[plateIndex]))
              } else {
                newColorArray.push('BLUE_WHITE_COLOR')
              }
            }
            
            // 构建更新请求（确保必填字段存在）
            const updatePayload = {
              orderId: orderId,
              plateNumbers: newPlateArray,
              plateColors: newColorArray.length > 0 ? newColorArray : undefined,
              // 保持其他字段不变
              productId: order?.productId || order?.product_id,
              status: order?.status,
              cardValidStartTime: order?.cardValidStartTime || order?.card_valid_start_time,
              cardValidEndTime: order?.cardValidEndTime || order?.card_valid_end_time,
              totalAmount: order?.totalAmount || order?.total_amount,
              paidAmount: order?.paidAmount || order?.paid_amount,
              actualAmount: order?.actualAmount || order?.actual_amount,
              // 添加操作人ID和操作描述
              operatorId: this.getOperatorId(),
              operatorName: this.getOperatorName(),
              operationDesc: `将车牌${oldPlate}修改为${newPlate}`
            }
            
            // 验证必填字段
            if (!updatePayload.totalAmount && updatePayload.totalAmount !== 0) {
              console.error('[vehicle] 订单缺少必填字段 totalAmount', { orderId, order })
              failCount++
              continue
            }
            
            console.log('[vehicle] 发送编辑请求', { orderId, updatePayload })
            await req({ url: updateUrl, method: 'post', data: updatePayload })
            successCount++
            console.log('[vehicle] 订单更新成功', { orderId, oldPlate, newPlate, newPlateColor })
            
            // 获取更新后的订单数据（用于更新 sessionStorage）
            const updatedOrder = await this.fetchLatestOrderData(orderId)
            if (updatedOrder) {
              updatedOrders.push(updatedOrder)
            } else {
              // 如果获取失败，使用更新后的数据构建订单对象
              updatedOrders.push({
                ...order,
                plateNumbers: newPlateArray,
                plateNumberList: newPlateArray,
                plateList: newPlateArray,
                plates: newPlateArray,
                plateColors: newColorArray,
                plate_colors: newColorArray
              })
            }
            
            // 添加操作记录（异步执行，不影响主流程）
            try {
              const businessId = this.getBusinessIdFromOrder(order)
              console.log('[vehicle] 编辑操作 - 获取 businessId:', { businessId, orderId, order })
              if (businessId && orderId) {
                await this.addOperationRecord(
                  orderId,
                  businessId,
                  `编辑车牌号：${oldPlate} → ${newPlate}`
                )
              } else {
                console.warn('[vehicle] 编辑操作 - 无法添加操作记录:', { businessId, orderId, order })
              }
            } catch (e) {
              // 操作记录添加失败不影响主流程
              console.error('[vehicle] 添加操作记录失败（不影响编辑操作）:', e)
            }
          } catch (e) {
            failCount++
            const errorMsg = e?.response?.data?.message || e?.message || String(e)
            const currentOrderId = order?.orderId || order?.id || order?.order_id || 'unknown'
            console.error('[vehicle] 更新订单失败', { 
              orderId: currentOrderId,
              order, 
              error: e,
              errorMessage: errorMsg,
              response: e?.response?.data
            })
          }
        }
        
        if (successCount > 0) {
          // 更新成功后，重新加载列表（从第一页开始）
          this.plateListPage = 1
          this.list = []
          this.plateToOrderMap = {}
          this.loadedOrderCount = 0
          this.plateListTotal = 0
          this.allPlateNumbersSet = null
          await this.fetchPlateList(this.currentBusinessId, this.currentProductId, 1, false)
          
          // 清空搜索关键词，因为车牌号已更新
          this.keyword = ''
          
          alert(`更新成功！共更新 ${successCount} 个订单${failCount > 0 ? `，${failCount} 个订单更新失败` : ''}`)
          this.closeEdit()
        } else {
          const errorDetails = failCount > 0 ? `（共 ${failCount} 个订单）` : ''
          alert(`更新失败！所有订单更新都失败了${errorDetails}。请查看浏览器控制台了解详细错误信息。`)
        }
      } catch (e) {
        console.error('[vehicle] 更新车牌号失败', e)
        alert(e?.response?.data?.message || '更新失败，请稍后再试')
      } finally {
        this.loading = false
      }
    },
    openClearAll () {
      if (!Array.isArray(this.list) || this.list.length === 0) return
      this.clearAllVisible = true
    },
    async doClearAll () {
      if (!Array.isArray(this.list) || this.list.length === 0) { 
        this.clearAllVisible = false
          return
        }

      try {
        this.clearAllVisible = false
        this.loading = true
        
        // 保存当前列表的副本（因为删除操作会修改列表）
        const itemsToDelete = [...this.list]
        
        let successCount = 0
        let failCount = 0
        const failedItems = [] // 记录删除失败的项
        const errorMessages = [] // 记录详细的错误信息
        const allUpdatedOrders = [] // 收集所有更新后的订单数据
        const orderIdSet = new Set() // 用于去重订单ID
        
        console.log('[vehicle] 一键清空开始', { totalCount: itemsToDelete.length })
        
        // 对每条记录执行删除操作（串行执行，避免并发问题）
        for (let i = 0; i < itemsToDelete.length; i++) {
          const item = itemsToDelete[i]
          if (!item || !item.num) {
            continue
          }
          
          const plate = item.num
          console.log('[vehicle] 一键清空：正在删除车牌号', { 
            index: i + 1, 
            total: itemsToDelete.length, 
            plate 
          })
          
          try {
            // 调用删除操作（不显示确认弹窗），获取更新后的订单数据
            const updatedOrders = await this.doDeleteInternal(item)
            successCount++
            
            // 收集更新后的订单数据（去重）
            if (Array.isArray(updatedOrders) && updatedOrders.length > 0) {
              updatedOrders.forEach(order => {
                const orderId = order?.orderId || order?.id || order?.order_id
                if (orderId && !orderIdSet.has(orderId)) {
                  orderIdSet.add(orderId)
                  allUpdatedOrders.push(order)
                }
              })
            }
            
            // 删除成功后，从列表中移除该项
            const indexInList = this.list.findIndex(l => {
              const normalized1 = String(l.num || '').trim().toUpperCase()
              const normalized2 = String(plate || '').trim().toUpperCase()
              return normalized1 === normalized2
            })
            if (indexInList >= 0) {
              this.list.splice(indexInList, 1)
              console.log('[vehicle] 一键清空：从列表中移除车牌号', { plate, indexInList })
            }
            
            // 更新映射关系（删除成功的车牌号）
            const normalizedPlate = String(plate).trim().toUpperCase()
            if (this.plateToOrderMap[normalizedPlate]) {
              delete this.plateToOrderMap[normalizedPlate]
              console.log('[vehicle] 一键清空：删除映射关系', { plate: normalizedPlate })
            }
          } catch (e) {
            failCount++
            failedItems.push(item)
            const errorMsg = e?.message || e?.response?.data?.message || String(e)
            errorMessages.push(`${plate}: ${errorMsg}`)
            console.error('[vehicle] 一键清空：删除记录失败', { 
              plate,
              index: i + 1,
              total: itemsToDelete.length,
              error: e,
              errorMessage: errorMsg
            })
            // 继续处理下一个，不中断整个流程
          }
        }
        
        console.log('[vehicle] 一键清空完成', { 
          successCount, 
          failCount, 
          totalCount: itemsToDelete.length 
        })
        
        if (successCount > 0) {
          // 一键清空成功后，重新加载列表（从第一页开始）
          this.plateListPage = 1
          this.list = []
          this.plateToOrderMap = {}
          this.loadedOrderCount = 0
          this.plateListTotal = 0
          this.allPlateNumbersSet = null
          await this.fetchPlateList(this.currentBusinessId, this.currentProductId, 1, false)
          
          // 更新 sessionStorage 中的订单数据
          if (allUpdatedOrders.length > 0) {
            this.updateSessionStorageOrders(allUpdatedOrders)
          }
          
          try {
            sessionStorage.setItem('deleteOperation', 'true')
            sessionStorage.setItem('deleteTimestamp', Date.now())
          } catch (e) { /* ignore */ }
          
          if (failCount > 0) {
            // 有部分失败，提示用户详细信息
            const errorDetail = errorMessages.length > 0 
              ? `\n\n失败详情：\n${errorMessages.slice(0, 5).join('\n')}${errorMessages.length > 5 ? `\n... 还有 ${errorMessages.length - 5} 个错误` : ''}`
              : ''
            alert(`部分清空成功！\n共删除 ${successCount} 条记录，${failCount} 条记录删除失败。\n失败的记录仍保留在列表中，可以稍后重试。${errorDetail}`)
          } else {
            // 全部成功
            alert(`清空成功！共删除 ${successCount} 条记录`)
          }
        } else {
          // 全部失败
          const errorDetail = errorMessages.length > 0 
            ? `\n\n错误详情：\n${errorMessages.slice(0, 10).join('\n')}${errorMessages.length > 10 ? `\n... 还有 ${errorMessages.length - 10} 个错误` : ''}`
            : ''
          alert(`清空失败！所有记录删除都失败了。请查看浏览器控制台了解详细错误信息。${errorDetail}`)
        }
      } catch (e) {
        console.error('[vehicle] 一键清空失败', e)
        alert(e?.response?.data?.message || e?.message || '清空失败，请稍后再试')
      } finally {
        this.loading = false
      }
    },
    // 获取订单最新数据
    async fetchLatestOrderData (orderId) {
      try {
        const req = (await import('@/utils/request')).default
        const getUrl = '/market/card/order/get'
        const resp = await req({ 
          url: getUrl, 
          method: 'get', 
          params: { id: orderId } 
        })
        const orderData = resp?.data?.data || resp?.data || resp
        if (orderData && (orderData.orderId || orderData.id || orderData.order_id)) {
          return orderData
        }
        return null
      } catch (e) {
        console.warn('[vehicle] 获取订单最新数据失败，将使用缓存数据', { orderId, error: e })
        return null
      }
    },
    // 更新 sessionStorage 中的订单数据
    updateSessionStorageOrders (updatedOrders) {
      try {
        const raw = sessionStorage.getItem('in_park_plates_payload')
        if (!raw) {
          console.warn('[vehicle] sessionStorage 中无数据，无法更新')
          return
        }
        
        const payload = JSON.parse(raw)
        if (!payload.businessContext) {
          payload.businessContext = {}
        }
        if (!payload.businessContext.orders) {
          payload.businessContext.orders = []
        }
        
        // 更新订单列表：用新的订单数据替换旧的订单数据
        const orderMap = new Map()
        // 先建立新订单的映射
        updatedOrders.forEach(order => {
          const orderId = order?.orderId || order?.id || order?.order_id
          if (orderId) {
            orderMap.set(orderId, order)
          }
        })
        
        // 更新现有订单列表
        const updatedOrderList = payload.businessContext.orders.map(existingOrder => {
          const orderId = existingOrder?.orderId || existingOrder?.id || existingOrder?.order_id
          if (orderId && orderMap.has(orderId)) {
            // 如果新数据中有该订单，使用新数据
            return orderMap.get(orderId)
          }
          // 否则保持原订单不变
          return existingOrder
        })
        
        // 如果有新订单（不在原列表中的），添加到列表末尾
        updatedOrders.forEach(order => {
          const orderId = order?.orderId || order?.id || order?.order_id
          if (orderId) {
            const exists = updatedOrderList.some(o => {
              const oid = o?.orderId || o?.id || o?.order_id
              return oid === orderId
            })
            if (!exists) {
              updatedOrderList.push(order)
            }
          }
        })
        
        payload.businessContext.orders = updatedOrderList
        
        // 保存更新后的数据
        sessionStorage.setItem('in_park_plates_payload', JSON.stringify(payload))
        console.log('[vehicle] 已更新 sessionStorage 中的订单数据', { 
          updatedOrderCount: updatedOrders.length,
          totalOrderCount: updatedOrderList.length 
        })
      } catch (e) {
        console.error('[vehicle] 更新 sessionStorage 失败', e)
      }
    },
    // 内部删除方法（不显示确认弹窗）
    async doDeleteInternal (item) {
      if (!item) return
      
      const plate = item.num
      if (!plate) {
        return
      }
      
      const req = (await import('@/utils/request')).default
      const updateUrl = '/market/card/order/update'
      const normalizedPlate = String(plate).trim().toUpperCase()
      
      // 获取该车牌号对应的月卡订单
      const orders = this.getOrdersByPlate(plate)
      if (!Array.isArray(orders) || orders.length === 0) {
        console.warn('[vehicle] 未找到该车牌号对应的月卡订单', { plate })
        // 如果没有找到订单，认为删除成功（可能已经被其他操作删除），返回空数组
        return []
      }
      
      let successOrderCount = 0
      let failOrderCount = 0
      const errors = []
      const updatedOrders = [] // 用于收集更新后的订单数据
      
      // 从每个订单中删除该车牌号
      for (const order of orders) {
        try {
          const orderId = order?.orderId || order?.id || order?.order_id
          if (!orderId) {
            console.warn('[vehicle] 订单ID为空，跳过删除', order)
            failOrderCount++
            errors.push('订单ID为空')
            continue
          }
          
          // 关键修复：在删除前先获取订单的最新数据，避免使用缓存中的旧数据
          // 这在批量删除时非常重要，因为前面的删除操作可能已经更新了订单数据
          let latestOrder = await this.fetchLatestOrderData(orderId)
          if (!latestOrder) {
            // 如果获取最新数据失败，使用缓存数据（向后兼容）
            console.warn('[vehicle] 无法获取订单最新数据，使用缓存数据', { orderId })
            latestOrder = order
          }
          
          // 使用最新订单数据获取车牌号列表
          const currentPlates = latestOrder?.plateNumbers || latestOrder?.plateNumberList || latestOrder?.plateList || latestOrder?.plates || []
          const plateArray = Array.isArray(currentPlates) ? [...currentPlates] : (currentPlates ? [currentPlates] : [])
          
          // 检查订单中是否包含要删除的车牌号
          const hasPlate = plateArray.some(p => {
            const normalized = String(p).trim().toUpperCase()
            return normalized === normalizedPlate
          })
          
          // 如果订单中不包含该车牌号，跳过（可能已经被其他操作删除）
          if (!hasPlate) {
            console.log('[vehicle] 订单中不包含该车牌号，跳过删除', { orderId, plate, plateArray })
            successOrderCount++ // 认为成功（目标已达成）
            continue
          }
          
          // 获取车牌颜色数组（使用最新订单数据）
          const currentColors = latestOrder?.plateColors || latestOrder?.plate_colors || []
          const colorArray = Array.isArray(currentColors) ? [...currentColors] : []
          
          // 同步构建新的车牌号数组和颜色数组，确保一一对应
          const newPlateArray = []
          const newColorArray = []
          
          plateArray.forEach((p, idx) => {
            const normalized = String(p).trim().toUpperCase()
            // 只保留非空且不是要删除的车牌号
            if (normalized.length > 0 && normalized !== normalizedPlate) {
              newPlateArray.push(normalized)
              // 同步保留对应的颜色，如果颜色数组长度不足则使用默认值
              if (idx < colorArray.length) {
                newColorArray.push(colorArray[idx])
              } else {
                // 如果颜色数组长度不足，根据车牌号自动识别颜色
                newColorArray.push(this.identifyPlateColor(normalized))
              }
            }
          })
          
          // 如果颜色数组长度不匹配，使用默认值补齐（理论上不应该发生，但作为保险）
          while (newColorArray.length < newPlateArray.length) {
            const plateIndex = newColorArray.length
            if (plateIndex < newPlateArray.length) {
              newColorArray.push(this.identifyPlateColor(newPlateArray[plateIndex]))
            } else {
              newColorArray.push('BLUE_WHITE_COLOR')
            }
          }
          
          // 构建更新请求（确保必填字段存在，使用最新订单数据）
          const updatePayload = {
            orderId: orderId,
            plateNumbers: newPlateArray,
            plateColors: newColorArray.length > 0 ? newColorArray : undefined,
            // 保持其他字段不变（使用最新订单数据）
            productId: latestOrder?.productId || latestOrder?.product_id || order?.productId || order?.product_id,
            status: latestOrder?.status || order?.status,
            cardValidStartTime: latestOrder?.cardValidStartTime || latestOrder?.card_valid_start_time || order?.cardValidStartTime || order?.card_valid_start_time,
            cardValidEndTime: latestOrder?.cardValidEndTime || latestOrder?.card_valid_end_time || order?.cardValidEndTime || order?.card_valid_end_time,
            // totalAmount 是必填字段
            totalAmount: latestOrder?.totalAmount || latestOrder?.total_amount || order?.totalAmount || order?.total_amount || 0,
            paidAmount: latestOrder?.paidAmount || latestOrder?.paid_amount || order?.paidAmount || order?.paid_amount || 0,
            actualAmount: latestOrder?.actualAmount || latestOrder?.actual_amount || order?.actualAmount || order?.actual_amount || 0,
            // 添加操作人ID和操作描述
            operatorId: this.getOperatorId(),
            operatorName: this.getOperatorName(),
            operationDesc: `删除车牌${normalizedPlate}`
          }
          
          // 验证必填字段
          if (!updatePayload.totalAmount && updatePayload.totalAmount !== 0) {
            console.error('[vehicle] 订单缺少必填字段 totalAmount', { orderId, latestOrder, order })
            failOrderCount++
            errors.push(`订单 ${orderId} 缺少必填字段 totalAmount`)
            continue
          }
          
          console.log('[vehicle] 准备删除车牌号', { 
            orderId, 
            plate, 
            normalizedPlate,
            beforePlates: plateArray,
            afterPlates: newPlateArray,
            hasLatestData: !!latestOrder && latestOrder !== order
          })
          
          await req({ url: updateUrl, method: 'post', data: updatePayload })
          successOrderCount++
          console.log('[vehicle] 订单车牌号删除成功', { orderId, plate, newPlateArray })
          
          // 获取更新后的订单数据（用于更新 sessionStorage）
          const updatedOrder = await this.fetchLatestOrderData(orderId)
          if (updatedOrder) {
            updatedOrders.push(updatedOrder)
          } else {
            // 如果获取失败，使用更新后的数据构建订单对象
            updatedOrders.push({
              ...latestOrder,
              plateNumbers: newPlateArray,
              plateNumberList: newPlateArray,
              plateList: newPlateArray,
              plates: newPlateArray,
              plateColors: newColorArray,
              plate_colors: newColorArray
            })
          }
          
          // 添加操作记录（异步执行，不影响主流程）
          try {
            const businessId = this.getBusinessIdFromOrder(latestOrder)
            console.log('[vehicle] 一键清空删除操作 - 获取 businessId:', { businessId, orderId, plate })
            if (businessId && orderId) {
              await this.addOperationRecord(
                orderId,
                businessId,
                `删除车牌号：${normalizedPlate}`
              )
            } else {
              console.warn('[vehicle] 一键清空删除操作 - 无法添加操作记录:', { businessId, orderId, plate })
            }
          } catch (e) {
            // 操作记录添加失败不影响主流程
            console.error('[vehicle] 添加操作记录失败（不影响删除操作）:', e)
          }
        } catch (e) {
          failOrderCount++
          const errorMsg = e?.response?.data?.message || e?.message || String(e)
          const currentOrderId = order?.orderId || order?.id || order?.order_id || 'unknown'
          errors.push(`订单 ${currentOrderId}: ${errorMsg}`)
          console.error('[vehicle] 删除订单车牌号失败', { 
            orderId: currentOrderId,
            plate,
            order, 
            error: e,
            errorMessage: errorMsg,
            response: e?.response?.data
          })
        }
      }
      
      // 注意：映射关系的删除应该在 doClearAll 中统一处理，而不是在这里
      // 这样可以确保只有真正删除成功的车牌号才会删除映射关系
      
      // 如果所有订单都删除失败，抛出错误
      if (failOrderCount > 0 && successOrderCount === 0) {
        const errorMessage = `删除车牌号 ${plate} 失败：所有订单删除都失败了。错误详情：${errors.join('; ')}`
        // 即使全部失败，也返回空数组（而不是 undefined）
        throw new Error(errorMessage)
      }
      
      // 如果部分订单删除失败，记录错误但不抛出（允许部分成功，以便 doClearAll 可以收集已成功更新的订单）
      if (failOrderCount > 0) {
        console.error('[vehicle] 部分订单删除失败', { 
          plate, 
          successOrderCount, 
          failOrderCount, 
          errors,
          errorMessage: `删除车牌号 ${plate} 部分失败：成功 ${successOrderCount} 个订单，失败 ${failOrderCount} 个订单。错误详情：${errors.join('; ')}`
        })
        // 不抛出错误，而是返回已成功更新的订单数据，让 doClearAll 决定如何处理
      }
      
      // 返回更新后的订单数据（即使有部分失败，也返回已成功更新的订单）
      return updatedOrders
    },
    addOne () { const t = new Date(); this.list.unshift({ num: '苏K' + Math.floor(Math.random()*90000+10000), time: t.toISOString().slice(0,16).replace('T',' ') }) }
  }
}
</script>

<style scoped>
.vmv-container {
  width: 100vw;
  max-width: 430px;
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 120px;
  box-sizing: border-box;
  margin: 0 auto;
}

.vmv-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
}

.vmv-header .back {
  position: absolute;
  left: 0;
  top: 0;
  height: 56px;
  display: flex;
  align-items: center;
  font-size: 26px;
  padding: 0 0 0 16px;
  cursor: pointer;
}

.vmv-header .title {
  font-size: 20px;
  font-weight: bold;
}

.vmv-search {
  width: 100%;
  background: #fff;
  padding: 12px 16px 0;
  box-sizing: border-box;
}

.vmv-search-box {
  display: flex;
  align-items: center;
  background: #f7f8fa;
  border-radius: 18px;
  padding: 0 8px;
  height: 36px;
  width: 70%;
  margin: 0 auto;
}

.vmv-search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 16px;
  height: 34px;
  color: #222;
  min-width: 0;
}

.vmv-search-btn {
  background: #3572e6;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.vmv-list {
  width: 100%;
  max-width: 430px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 12px 0 0;
  height: calc(100vh - 180px);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.vmv-plate-card {
  background: #fff;
  border-radius: 16px;
  margin: 0 16px 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  gap: 12px;
}

.vmv-plate-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.vmv-plate-header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;
}

.vmv-plate-number {
  font-size: 16px;
  font-weight: bold;
  color: #222;
  flex-shrink: 0;
  line-height: 1.4;
}

.vmv-plate-info {
  font-size: 11px;
  color: #888;
  line-height: 1.4;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vmv-plate-status {
  background: #e6ffe6;
  color: #09bb07;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.vmv-right-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-left: 8px;
}

.vmv-edit-btn {
  background: #3572e6;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}
.vmv-edit-btn:hover {
  background: #2968d4;
}
.vmv-edit-btn:active {
  background: #1f5bb8;
}

.vmv-delete-btn {
  background: #ff4444;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}
.vmv-delete-btn:hover {
  background: #e63939;
}
.vmv-delete-btn:active {
  background: #cc2e2e;
}

.vmv-arrow {
  color: #999;
  font-size: 18px;
  margin-left: 4px;
  flex-shrink: 0;
}

/* 自定义确认弹窗样式 */
.confirm-mask {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.confirm-dialog {
  width: 86%;
  max-width: 420px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(0,0,0,0.18);
  padding: 16px 16px 12px 16px;
}
.confirm-title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
  margin-bottom: 8px;
}
.confirm-content {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}
.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 14px;
}
.confirm-actions .btn {
  min-width: 84px;
  height: 36px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
}
.confirm-actions .btn.cancel {
  background: #f4f4f4;
  color: #555;
}
.confirm-actions .btn.danger {
  background: linear-gradient(90deg,#ff5858,#ff8844);
  color: #fff;
}
.confirm-actions .btn:disabled { opacity: .6; cursor: not-allowed; }
.confirm-actions .btn.primary {
  background: linear-gradient(90deg,#4ca1ff,#70e1f5);
  color: #fff;
}

/* 编辑弹窗样式 */
.edit-dialog {
  max-width: 380px;
}
.edit-form {
  margin: 12px 0;
}
.edit-label {
  font-size: 14px;
  color: #555;
  margin-bottom: 6px;
  font-weight: 500;
}
.edit-current-plate {
  font-size: 16px;
  color: #222;
  font-weight: bold;
  margin-bottom: 16px;
  padding: 8px 12px;
  background: #f7f8fa;
  border-radius: 8px;
}
.edit-input {
  width: 100%;
  padding: 10px 12px;
  font-size: 16px;
  border: 1.5px solid #e0e0e0;
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
.edit-input:focus {
  border-color: #4ca1ff;
}
.edit-input-plate {
  width: 100%;
  padding: 10px 12px;
  font-size: 16px;
  border: 1.5px solid #e0e0e0;
  border-radius: 8px;
  box-sizing: border-box;
  transition: border-color 0.2s;
  background: #fff;
  cursor: pointer;
  min-height: 40px;
  display: flex;
  align-items: center;
}
.edit-input-plate:hover {
  border-color: #4ca1ff;
}
.plate-display {
  color: #222;
  font-weight: 500;
}
.plate-placeholder {
  color: #999;
}

.vmv-bottom-btns {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 60px;
  max-width: 430px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 8px 16px;
  border-top: 1.5px solid #eee;
  z-index: 100;
}

.load-more-loading, .load-more-hint {
  text-align: center;
  color: #999;
  padding: 16px 0;
  font-size: 14px;
}
</style>

